import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import PublicLayout from '../components/PublicLayout.vue'
import AuthenticatedLayout from '../components/AuthenticatedLayout.vue'
import HomeView from '../views/HomeView.vue'
import FrontofficeHome from '../views/FrontofficeHome.vue'
import FrontofficeCollectivites from '../views/FrontofficeCollectivites.vue'
import FrontofficeWallet from '../views/FrontofficeWallet.vue'
import FrontofficeMarket from '../views/FrontofficeMarket.vue'
import FrontofficeCarte from '../views/FrontofficeCarte.vue'
import FrontofficeBudget from '../views/FrontofficeBudget.vue'
import FrontofficeProfil from '../views/FrontofficeProfil.vue'
import MonProfil from '../views/profil/MonProfil.vue'
import ChangerPin from '../views/profil/ChangerPin.vue'
import InformationsPersonnelles from '../views/profil/InformationsPersonnelles.vue'
import PlanMensuel from '../views/profil/PlanMensuel.vue'
import MaSouscription from '../views/profil/MaSouscription.vue'
import MonPouvoirAchat from '../views/profil/MonPouvoirAchat.vue'
import WalletDashboard from '../views/wallet/WalletDashboard.vue'
import WalletUtilisation from '../views/wallet/WalletUtilisation.vue'
import WalletTransactionDetail from '../views/wallet/WalletTransactionDetail.vue'
import FrontofficeAide from '../views/FrontofficeAide.vue'
import FrontofficeChangerPin from '../views/FrontofficeChangerPin.vue'
import FrontofficeKyc from '../views/FrontofficeKyc.vue'
import CollectivitesDashboard from '../views/CollectivitesDashboard.vue'
import CollectivitesOnboardingGroupe from '../views/collectivites/CollectivitesOnboardingGroupe.vue'
import MaCollectivite from '../views/collectivites/MaCollectivite.vue'
import MaCollectiviteEdit from '../views/collectivites/MaCollectiviteEdit.vue'
import CollectivitesMembres from '../views/collectivites/CollectivitesMembres.vue'
import CollectiviteMembreDetail from '../views/collectivites/CollectiviteMembreDetail.vue'
import CollectiviteMembreEdit from '../views/collectivites/CollectiviteMembreEdit.vue'
import CollectiviteMembreCarte from '../views/collectivites/CollectiviteMembreCarte.vue'
import CollectiviteMembreUtilisation from '../views/collectivites/CollectiviteMembreUtilisation.vue'
import CollectiviteMembrePlan from '../views/collectivites/CollectiviteMembrePlan.vue'
import CollectiviteMembreRevolving from '../views/collectivites/CollectiviteMembreRevolving.vue'
import CollectivitesRecouvrement from '../views/collectivites/CollectivitesRecouvrement.vue'
import KycMembresList from '../views/collectivites/KycMembresList.vue'
import KycMembreDetail from '../views/collectivites/KycMembreDetail.vue'
import CollectivitesLayout from '../layouts/CollectivitesLayout.vue'
import WalletLayout from '../layouts/WalletLayout.vue'
import CarteLayout from '../layouts/CarteLayout.vue'
import BudgetLayout from '../layouts/BudgetLayout.vue'
import CarteTransactions from '../views/carte/CarteTransactions.vue'
import CarteRepartition from '../views/carte/CarteRepartition.vue'
import CarteParametres from '../views/carte/CarteParametres.vue'
import BudgetPrevisions from '../views/budget/BudgetPrevisions.vue'
import BudgetCategories from '../views/budget/BudgetCategories.vue'
import MarketProduits from '../views/MarketProduits.vue'
import SignIn from '../views/auth/SignIn.vue'
import SignInOtp from '../views/auth/SignInOtp.vue'
import SignUp from '../views/auth/SignUp.vue'
import SignUpKyc from '../views/auth/SignUpKyc.vue'
import SignUpKyc2 from '../views/auth/SignUpKyc2.vue'
import SignUpBack from '../views/auth/SignUpBack.vue'
import SignUpCollectivite from '../views/auth/SignUpCollectivite.vue'
import SignUpActivation from '../views/auth/SignUpActivation.vue'
import SignUpQuotite from '../views/auth/SignUpQuotite.vue'
import ForgetPassword from '../views/auth/ForgetPassword.vue'
import ForgetPasswordReset from '../views/auth/ForgetPasswordReset.vue'
import Otp from '../views/auth/Otp.vue'
import InvitationView from '../views/auth/InvitationView.vue'
import FaqListView from '@/views/FaqListView.vue'
import { API_CONFIG } from '@/services/apiConfig'
import TutorialsListView from '@/views/aide/TutorialsListView.vue'
import TutorialsDetailsView from '@/views/aide/TutorialsDetailsView.vue'

// Pages d'aide
import FaqView from '../views/aide/FaqView.vue'
import TutorielView from '../views/aide/TutorielView.vue'
import TutorielDetailView from '../views/aide/TutorielDetailView.vue'
import ServiceClientView from '../views/aide/ServiceClientView.vue'
import LiveTchatView from '../views/aide/LiveTchatView.vue'
import LiveTchatsView from '../views/aide/LiveTchatsView.vue'

// Pages Market
import ProduitsView from '../views/market/ProduitsView.vue'
import PanierView from '../views/market/PanierView.vue'
import ProduitsDetailsView from '@/views/market/ProduitsDetailsView.vue'
import MarketView from '@/views/market/MarketView.vue'
import FrontOfficeCommandes from '@/views/FrontOfficeCommandes.vue'
import FrontOfficeMarketLayout from '@/views/FrontOfficeMarketLayout.vue'
import MarketCheckoutView from '@/views/market/views/marcket-checkout/MarketCheckoutView.vue'
import axios from 'axios'
import FrontOfficeCommandesDetails from '@/views/FrontOfficeCommandesDetails.vue'

const routes: Array<RouteRecordRaw> = [
  // Routes publiques avec PublicLayout
  {
    path: '/',
    component: PublicLayout,
    children: [
      {
        path: '',
        name: 'home',
        component: FrontofficeHome
      },
      {
        path: 'market',
        component: MarketView
      },
      {
        path: 'market/produits',
        name: 'market-produits-public',
        component: ProduitsView
      },
      {
        path: 'market/produits/:slug',
        component: ProduitsDetailsView
      },
      {
        path: 'market/panier',
        name: 'market-panier',
        component: PanierView
      },
     
      {
        path: 'about',
        name: 'about',
        component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
      },
      
      // FAQ
      { 
        path: "faq", 
        name: "faq",
        component: FaqListView,
        beforeEnter: async (to, from, next) => {
          try {
            const response = await fetch(`${API_CONFIG.baseURL}/faq`, {
                method: 'GET',
                headers: API_CONFIG.headers
            });
            to.meta.startup_infos = await response.json();
            next();
          } catch (e) {
            next(false)
          }
        }  
      },
      
      // TUTORIEL
      { 
        path: "tutoriels", 
        component: TutorialsListView,
        beforeEnter: async (to, from, next) => {
          try {
            const response = await fetch(`${API_CONFIG.baseURL}/tutoriels`, {
                method: 'GET',
                headers: API_CONFIG.headers
            });
            to.meta.startup_infos = await response.json();
            next();
          } catch (e) {
            next(false)
          }
        }  
      },
      { 
        path: "tutoriels/:slug", 
        component: TutorialsDetailsView,
        beforeEnter: async (to, from, next) => {
          try {
            const response = await fetch(`${API_CONFIG.baseURL}/tutoriels/${to.params.slug}`, {
                method: 'GET',
                headers: API_CONFIG.headers
            });
            to.meta.startup_infos = await response.json();
            to.meta.prevRoute = from.path.includes('tutoriels') ? from.path : '/tutoriels';
            next();
          } catch (e) {
            next(false)
          }
        }  
      },
    ]
  },

  // Routes d'authentification avec PublicLayout
  {
    path: '/auth',
    component: PublicLayout,
    children: [
      // Connexion
      { path: 'sign-in', name: 'sign-in', component: SignIn },
      { path: 'sign-in-otp', name: 'sign-in-otp', component: SignInOtp },

      // Inscription
      { path: 'sign-up', name: 'sign-up', component: SignUp },
      { path: 'sign-up-quotite', name: 'sign-up-quotite', component: SignUpQuotite },
      { path: 'sign-up-kyc', name: 'sign-up-kyc', component: SignUpKyc },
      { path: 'sign-up-kyc2', name: 'sign-up-kyc2', component: SignUpKyc2 },
      { path: 'sign-up-back', name: 'sign-up-back', component: SignUpBack },
      { path: 'sign-up-collectivite', name: 'sign-up-collectivite', component: SignUpCollectivite },
      { path: 'sign-up-activation', name: 'sign-up-activation', component: SignUpActivation },

      // Mot de passe oublié
      { path: 'forget-password', name: 'forget-password', component: ForgetPassword },
      { path: 'forget-password-reset', name: 'forget-password-reset', component: ForgetPasswordReset },

      // OTP (ancien)
      { path: 'otp', name: 'otp', component: Otp },
    ]
  },

  // Route d'invitation (en dehors de /auth pour correspondre à l'URL de l'email)
  {
    path: '/invitation/:code',
    name: 'invitation',
    component: InvitationView
  },

  // Redirections pour rétrocompatibilité
  { path: '/login', redirect: '/auth/sign-in' },
  { path: '/signin', redirect: '/auth/sign-in' },
  { path: '/signin-otp', redirect: '/auth/sign-in-otp' },
  { path: '/signup', redirect: '/auth/sign-up' },
  { path: '/signup-kyc', redirect: '/auth/sign-up-kyc' },
  { path: '/signup-kyc2', redirect: '/auth/sign-up-kyc2' },
  { path: '/signup-back', redirect: '/auth/sign-up-back' },
  { path: '/signup-collectivite', redirect: '/auth/sign-up-collectivite' },
  { path: '/signup-activation', redirect: '/auth/sign-up-activation' },
  { path: '/forget-password', redirect: '/auth/forget-password' },
  { path: '/forget-password-reset', redirect: '/auth/forget-password-reset' },

  // Routes authentifiées avec AuthenticatedLayout
  {
    path: '/front',
    component: AuthenticatedLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        redirect: '/front/wallet'
      },
      {
        path: 'collectivites',
        component: CollectivitesLayout,
        children: [
          {
            path: '',
            name: 'collectivites',
            component: FrontofficeCollectivites
          },
          {
            path: 'ma-collectivite',
            name: 'ma-collectivite',
            component: MaCollectivite
          },
          {
            path: 'ma-collectivite/edit',
            name: 'ma-collectivite-edit',
            component: MaCollectiviteEdit
          },
          {
            path: 'onboarding-groupe',
            name: 'collectivites-onboarding-groupe',
            component: CollectivitesOnboardingGroupe
          },
          {
            path: 'dashboard',
            name: 'collectivites-dashboard',
            component: CollectivitesDashboard
          },
          {
            path: 'membres',
            name: 'collectivites-membres',
            component: CollectivitesMembres
          },
          {
            path: 'membres/:id',
            name: 'collectivites-membre-detail',
            component: CollectiviteMembreDetail
          },
          {
            path: 'membres/:id/edit',
            name: 'collectivites-membre-edit',
            component: CollectiviteMembreEdit
          },
          {
            path: 'membres/:id/carte',
            name: 'collectivites-membre-carte',
            component: CollectiviteMembreCarte
          },
          {
            path: 'membres/:id/utilisation',
            name: 'collectivites-membre-utilisation',
            component: CollectiviteMembreUtilisation
          },
          {
            path: 'membres/:id/plan',
            name: 'collectivites-membre-plan',
            component: CollectiviteMembrePlan
          },
          {
            path: 'membres/:id/revolving',
            name: 'collectivites-membre-revolving',
            component: CollectiviteMembreRevolving
          },
          {
            path: 'kyc-membres',
            name: 'collectivites-kyc-membres',
            component: KycMembresList
          },
          {
            path: 'kyc-membres/:id',
            name: 'collectivites-kyc-membre-detail',
            component: KycMembreDetail
          },
          {
            path: 'recouvrement',
            name: 'collectivites-recouvrement',
            component: CollectivitesRecouvrement
          }
        ]
      },
      {
        path: 'wallet',
        component: WalletLayout,
        children: [
          {
            path: '',
            name: 'wallet',
            component: WalletDashboard
          },
          {
            path: 'utilisation',
            name: 'wallet-utilisation',
            component: WalletUtilisation
          },
          {
            path: 'transaction/:id',
            name: 'wallet-transaction-detail',
            component: WalletTransactionDetail
          }
        ]
      },
      {
        path: 'market',
        component: FrontOfficeMarketLayout,
        children: [
          {
            path: 'portail',
            component: MarketView,
            beforeEnter: async (to, from, next) => {
              to.meta.layout = "frontoffice";
              next();
            }
          },
          {
            path: 'commandes',
            component: FrontOfficeCommandes
          },
          {
            path: 'commandes/:id',
            component: FrontOfficeCommandesDetails,
            beforeEnter: async (to, from, next) => {
              try {
                const res = await axios.get(`/market/commands/${to.params.id}`);
                to.meta.commande = res.data.commande;
                next();
              } catch (e) {
                next(false)
              }
            }
          },
          {
            path: 'panier',
            component: PanierView,
            beforeEnter: async (to, from, next) => {
              to.meta.layout = "frontoffice";
              next();
            }
          },
          {
            path: 'checkout',
            component: MarketCheckoutView,
            beforeEnter: async (to, from, next) => {
              try {
                const res = await axios.get(`/market/checkout_startup_infos`);
                to.meta.startup_infos = res.data;
                to.meta.layout = "frontoffice";
                next();
              } catch (e) {
                next(false)
              }
            }
          },
          {
            path: 'produits',
            component: ProduitsView,
            beforeEnter: async (to, from, next) => {
              to.meta.layout = "frontoffice";
              next();
            }
          },
          {
            path: 'produits/:id',
            component: ProduitsDetailsView,
            beforeEnter: async (to, from, next) => {
              try {
                const res = await axios.get(`/market/products/${to.params.id}`);
                to.meta.startup_infos = res.data;
                to.meta.layout = "frontoffice";
                next();
              } catch (e) {
                next(false)
              }
              next();
            }
          },
        ]
      },
      {
        path: 'ma-carte',
        component: CarteLayout,
        children: [
          {
            path: '',
            name: 'carte',
            component: FrontofficeCarte
          },
          {
            path: 'transactions',
            name: 'carte-transactions',
            component: CarteTransactions
          },
          {
            path: 'repartition',
            name: 'carte-repartition',
            component: CarteRepartition
          },
          {
            path: 'parametres',
            name: 'carte-parametres',
            component: CarteParametres
          }
        ]
      },
      {
        path: 'budget',
        component: BudgetLayout,
        children: [
          {
            path: '',
            name: 'budget',
            component: FrontofficeBudget
          },
          {
            path: 'previsions',
            name: 'budget-previsions',
            component: BudgetPrevisions
          },
          {
            path: 'categories',
            name: 'budget-categories',
            component: BudgetCategories
          }
        ]
      },
      {
        path: 'profil',
        component: FrontofficeProfil,
        children: [
          {
            path: '',
            name: 'profil',
            component: MonProfil
          },
          {
            path: 'changer-pin',
            name: 'profil-changer-pin',
            component: ChangerPin
          },
          {
            path: 'kyc',
            name: 'profil-kyc',
            component: FrontofficeKyc
          },
          {
            path: 'informations-personnelles',
            name: 'profil-informations-personnelles',
            component: InformationsPersonnelles
          },
          {
            path: 'plan-mensuel',
            name: 'profil-plan-mensuel',
            component: PlanMensuel
          },
          {
            path: 'ma-souscription',
            name: 'profil-souscription',
            component: MaSouscription
          },
          {
            path: 'pouvoir-achat',
            name: 'profil-pouvoir-achat',
            component: MonPouvoirAchat
          }
        ]
      },
      {
        path: 'changer-pin',
        redirect: '/front/profil/changer-pin'
      },
      {
        path: 'kyc',
        redirect: '/front/profil/kyc'
      },
      {
        path: 'aide',
        name: 'aide',
        component: FrontofficeAide
      },
      /*{
        path: 'aide/faq',
        name: 'aide-faq',
        component: FaqView
      },
      {
        path: 'aide/tutoriels',
        name: 'aide-tutoriels',
        component: TutorielView
      },
      {
        path: 'aide/tutoriels/:slug',
        name: 'aide-tutoriel-detail',
        component: TutorielDetailView
      },*/
      {
        path: 'aide/service-client',
        name: 'aide-service-client',
        component: ServiceClientView
      },
      {
        path: 'aide/live-tchats',
        name: 'aide-live-tchats',
        component: LiveTchatsView
      },
      {
        path: 'aide/live-tchat/:id?',
        name: 'aide-live-tchat',
        component: LiveTchatView
      },
    ]
  },

  // Redirection dashboard vers front
  { path: '/dashboard', redirect: '/front' }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Guard de route pour protéger les pages nécessitant une authentification
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const token = localStorage.getItem('auth_token')
    const userData = localStorage.getItem('user_data')

    let parsedUser: Record<string, unknown> | null = null
    if (userData) {
      try {
        parsedUser = JSON.parse(userData)
      } catch {
        localStorage.removeItem('user_data')
      }
    }

    const userId = parsedUser && (parsedUser['id'] as number | string | undefined)

    if (!token || !userId) {
      next({ path: '/auth/sign-in', query: { redirect: to.fullPath } })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
